import { create } from 'zustand'

import { MessageType } from '@/shared/api'

type ErrorDialogType = MessageType.ALERT | MessageType.CONFIRM

export type ErrorDialogProps = {
  title?: string
  content: string
  cancelText?: string
  confirmText?: string
  type: ErrorDialogType
  onConfirm?: (() => void) | null
}

export type ErrorDialogState = {
  isOpen: boolean
  title?: string
  content: string
  cancelText?: string
  confirmText?: string
  type: ErrorDialogType
  onConfirm: (() => void) | null
  actions: {
    toggle: () => void
    open: (props: ErrorDialogProps) => void
    close: () => void
  }
}

const defaultState: Omit<ErrorDialogState, 'actions'> = {
  isOpen: false,
  title: '',
  content: '',
  cancelText: '닫기',
  confirmText: '확인',
  type: MessageType.ALERT,
  onConfirm: null,
}

export const useErrorDialogStore = create<ErrorDialogState>()(set => ({
  ...defaultState,
  actions: {
    toggle: () => {
      set(state => ({ isOpen: !state.isOpen }))
    },
    open: (props: ErrorDialogProps) => {
      set(state => ({
        ...state,
        ...props,
        isOpen: true,
      }))
    },
    close: () => {
      set(defaultState)
    },
  },
}))
